<!-- <div class="d_flex d-flex  py-3 py-md-1"> -->
<div class="container-fluid d_flex" id="">
  <div class="row justify-content-center py-4">
    <div class="col-12 col-md-10 col-lg-8 col-xxl-7">
      <div class="card login-card">
        <div class="card-body">
          <div class="row justify-content-center">
            <div class="col-12 mt-0 ms-4">
              <a class="arrowBtn btn btn-sm btn-outline-dark" routerLink="/login">
                <i class="bi bi-arrow-left"></i>
              </a>
            </div>
            <div class="col-12 text-center">
              <div class="brand-wrapper">
                <img src="assets/img/logo.png" alt="logo" class="logo">
              </div>
              <p class="login-card-description" style="font-size: large;">{{"PROFILE.SIGNUP.SUBSCRIBE" | translate}}
              </p>
              <p style="font-size: small; margin-bottom: 23px; color: red;">{{"PROFILE.SIGNUP.MANDATORY" | translate}}
              </p>

            </div>
            <div class="container">
              <form [formGroup]="signupForm" class="has-validation" style="margin: 0 auto;">
                <div class="form-group">
                  <div class="row p-3">
                    <div class="col-12 col-lg-6 mb-3">
                      <label for="name" style="font-weight: bold;">{{"PROFILE.SIGNUP.NAME" | translate}}<sup
                          class="small-asterisk">*</sup></label>
                      <input type="text" id="name" formControlName="name" class="form-control form_control"
                        placeholder="">
                    </div>

                    <div class="col-12 col-lg-6 mb-3">
                      <label for="surname" style="font-weight: bold;">{{"PROFILE.SIGNUP.SURNAME" |
                        translate}}<sup class="small-asterisk">*</sup></label>
                      <input type="text" id="surname" formControlName="surname" class="form-control form_control"
                        placeholder="">
                    </div>

                    <div class="col-12 col-lg-6 mb-3">
                      <label for="company_name" style="font-weight: bold;">{{"PROFILE.SIGNUP.COMPANY" |
                        translate}}</label>
                      <input formControlName="company_name" class="form-control form_control"
                        placeholder='{{"PROFILE.SIGNUP.OPTIONALPLACEHOLDER" | translate}}'
                        [ngClass]="{'error': !validEmail}">
                    </div>

                    <div class="col-12 col-lg-6 mb-3">
                      <label for="country" style="font-weight: bold;">{{"PROFILE.SIGNUP.COUNTRY" |
                        translate}}<sup class="small-asterisk">*</sup></label>
                      <select class="form-select form_select" id="country" aria-label="select example"
                        formControlName="country">
                        <option [ngValue]="null" disabled selected>{{"PROFILE.SIGNUP.SELECTCOUNTRY" |
                          translate}}</option>
                        <option *ngFor="let country of countriesData" [ngValue]="country.id">
                          <!-- <img src="{{country.flag_png}}" width="20px" height="15px">  -->
                          {{country.common_name }}
                        </option>
                      </select>
                      <!-- <mat-select formControlName="country">
                                    @for (country of countriesData; track country) {
                                      <mat-option [value]="country">
                                        <img src="{{country.flags}}" style="width: 15px; height: auto;">
                                        {{country.name}}
                                    </mat-option>
                                    }
                            </mat-select> -->
                    </div>

                    <div *ngIf="!isItalian; else vatBlock" class="col-12 col-lg-6 mb-3">
                      <label for="licensenumber" style="font-weight: bold;">{{"PROFILE.SIGNUP.LICENSENUMBER" |
                        translate}}<sup class="small-asterisk">*</sup></label>
                      <input id="licensenumber" formControlName="licensenumber" class="form-control form_control"
                        placeholder="">
                    </div>
                    <ng-template #vatBlock>
                      <div *ngIf="isItalian" class="col-12 col-lg-6 mb-3">
                        <label for="vat" style="font-weight: bold;">{{"PROFILE.SIGNUP.VAT" | translate}}</label>
                        <input id="vat" formControlName="vat" class="form-control form_control"
                          placeholder='{{"PROFILE.SIGNUP.OPTIONALPLACEHOLDER" | translate}}'>
                      </div>
                    </ng-template>

                    <div *ngIf="isItalian" class="col-12 col-lg-6 mb-3">
                      <label for="fiscalcode" style="font-weight: bold;">{{"PROFILE.SIGNUP.FISCALCODE" |
                        translate}}<sup class="small-asterisk">*</sup></label>
                      <input type="text" id="fiscalcode" formControlName="fiscalcode" class="form-control form_control"
                        placeholder="">
                    </div>

                    <div class="col-12 col-lg-6 mb-3 mb-lg-1">
                      <label for="email" style="font-weight: bold;">{{"PROFILE.SIGNUP.EMAIL" | translate}}<sup
                          class="small-asterisk">*</sup></label>
                      <input type="email" id="email" formControlName="email" class="form-control form_control"
                        placeholder="" [ngClass]="{'error': signupForm.get('email')?.invalid && signupForm.get('email')?.dirty }">
                        <div class="text-form" *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.dirty"
                        style="color: red; font-size: small;">
                            Invalid email{{"PROFILE.SIGNUP.INVALIDEMAIL" | translate}}
                        </div>
                    </div>

                    <div class="col-12 col-lg-6 mb-3 mb-lg-0" [ngClass]="{'mb-lg-3': isItalian}" style="position: relative;">
                      <label for="password" style="font-weight: bold;">{{"PROFILE.SIGNUP.PWD" | translate}}<sup
                          class="small-asterisk">*</sup></label>
                      <input [type]="type1" id="password" formControlName="password" class="form-control form_control"
                        placeholder="********"
                        [ngClass]="{'error': signupForm.hasError('mismatch') && (signupForm.get('password')?.dirty && signupForm.get('password_confirmation')?.dirty)}">
                      <i class="bi bi-eye icon" [ngClass]="{'bi-eye': !toggled1, 'bi-eye-slash': toggled1}"
                        id="togglePassword" (click)="seePassword('password')"></i>
                    </div>
                    <div class="col-12 col-lg-6" style="position: relative;">
                      <label for="password_confirmation" style="font-weight: bold;">{{"PROFILE.SIGNUP.PWD_CONFIRM" |
                        translate}}<sup class="small-asterisk">*</sup></label>
                      <input [type]="type2" id="password_confirmation" formControlName="password_confirmation"
                        class="form-control form_control" placeholder="********"
                        [ngClass]="{'error': signupForm.hasError('mismatch') && (signupForm.get('password')?.dirty && signupForm.get('password_confirmation')?.dirty)}">
                      <i class="bi bi-eye icon" [ngClass]="{'bi-eye': !toggled2, 'bi-eye-slash': toggled2}"
                        id="togglePassword" (click)="seePassword('password_confirmation')"></i>
                    </div>
                    <div class="col-12 mb-3">
                      <span class="mt-1" *ngIf="signupForm.hasError('mismatch') && (signupForm.get('password')?.dirty && signupForm.get('password_confirmation')?.dirty)"
                      style="color: red; font-size: small;">
                        {{"PROFILE.SIGNUP.PSWMISMATCH" | translate}}
                      </span>
                    </div>

                    <div class="col-12 col-lg-6 mb-3">
                      <label for="phone" style="font-weight: bold;">{{"PROFILE.SIGNUP.PHONE" | translate}}<sup
                          class="small-asterisk">*</sup></label>
                      <input type="text" id="phone" formControlName="phone" class="form-control form_control"
                        placeholder='{{"PROFILE.SIGNUP.PHONEPLACEHOLDER" | translate}}'>
                    </div>

                    <div class="col-12 col-lg-6 mb-3">
                      <label for="phone_whatsapp" style="font-weight: bold;">{{"PROFILE.SIGNUP.WHATSAPP" |
                        translate}}</label>
                      <input type="text" id="phone_whatsapp" formControlName="phone_whatsapp"
                        class="form-control form_control"
                        placeholder='{{"PROFILE.SIGNUP.OPTIONALPLACEHOLDER" | translate}}'>
                    </div>

                    <div class="col-12 mb-3">
                      <label for="request_description" style="font-weight: bold;">{{"PROFILE.SIGNUP.INFO" |
                        translate}}</label>
                      <textarea id="request_description" rows="3" formControlName="request_description"
                        class="form-control" placeholder='{{"PROFILE.SIGNUP.INFOPLACEHOLDER" | translate}}'>
                            </textarea>
                    </div>

                    <div class="col-12 mb-3">
                      <re-captcha name="recaptcha" formControlName="recaptcha"></re-captcha>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center">
                  <label *ngIf="signupForm.invalid" class="mb-2" for="sendBtn"
                    style="font-size: small; color: red;">{{"PROFILE.SIGNUP.INVALID" | translate}}</label><br>
                  <button class="btn btn-block send-btn mb-4" id="sendBtn" type="button" (click)="sendSignupData()"
                    [disabled]="signupForm.invalid">
                    {{"PROFILE.SIGNUP.SEND" | translate}}
                  </button>
                </div>
              </form>
            </div>
            <nav class="login-card-footer-nav text-center mb-2">
              {{"PROFILE.SIGNUP.ACCEPTANCEPT1" | translate}}
              <a href="#!" class="ms-1 me-1">{{"PROFILE.SIGNUP.USERTERMS" | translate}}</a>
              {{"PROFILE.SIGNUP.ACCEPTANCEPT2" | translate}}
              <a href="#!" class="ms-1">{{"PROFILE.SIGNUP.PRIVACY" | translate}}</a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!-- </div> -->
